import { z } from "zod";

import { ibanSchema } from "@/lib/validations/iban";
import i18next from "i18next";

export const paymentSchema = z.object({
  currency: z.string().refine((val) => val === "EUR", {
    message: i18next.t("validation.payment.currency"),
  }),
  recipientIban: ibanSchema,
  amount: z.number().min(0, {
    message: i18next.t("validation.payment.amount"),
  }),
  purpose: z.union([z.string().min(1).max(140), z.null()]).optional(),
});
